/**
 * <Login
 *	/>
 *
 * This is ...
 *
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 * @redux
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import { connect } from 'react-redux';
import bg from '../../../data/images/login.jpg';
import logo from 'data/images/logo_white@2x.png';
import PhoneNumber from 'components/Form/Fields/PhoneNumber';
import loginAsUser from 'controllers/user/loginAsUser';
import sendPhoneVerification from 'controllers/user/sendPhoneVerification'
import registerUser from 'controllers/user/registerUser';
import beginTrial from 'controllers/user/startTrial';
import getSubscriptionCtrl from 'controllers/payment/getSubscription';
import ForgotPassword from 'template/Modals/ForgotPassword';
import validator from 'validator';
import getUserByToken from 'controllers/user/getUserByToken'
import Loading from 'components/UI/Loading';
import locale from './locale';
import { alert } from 'util/alert'

import './Login.scss';

const DEFAULT_NUMBER = '1'
const DEFAULT_REGION_CODE = 'ca';
const COUNT_DOWN_SECONDS = 59

const mapStateToProps = state => ({

});

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.login = this.login.bind(this);
    this.forgotPassword = this.forgotPassword.bind(this);
    this.registerUser = this.registerUser.bind(this);
    this.sendVerificationCode = this.sendVerificationCode.bind(this);
    this.startTrial = this.startTrial.bind(this);
    this.state = {
      username: {country_code: DEFAULT_NUMBER, national_number: '', region_code: DEFAULT_REGION_CODE},
      password: '',
      signingIn: false,
      pageState: 'login',
      showPassword: false,
      verificationCode: '',
      showMsg: false,
      showVerificationFailure: false,
      counterTime: COUNT_DOWN_SECONDS,
      resendCode: false,
      newPassword: '',
      email: '',
      agentId: '',
      errorMessage: ''
    }
  }

  componentWillMount() {
    localStorage.removeItem('token')
  }

  forgotPassword() {
    ForgotPassword()
    .then((a)=>{
    })
    .catch(()=>{});
  }

  login() {
    const {
      username,
      password,
    } = this.state;

    this.setState({
      signingIn: true,
    });

    loginAsUser({ username: username.country_code + username.national_number, password }).then((res)=>{
      if (!res.data) {
        return;
      }

      const {
        result,
        user_token,
        reason
      } = res.data;

      if (result === 'failure') {
        this.setState({
          errorMessage: reason,
          signingIn: false,
        });
      } else if (result === 'success') {
        localStorage.setItem('token', user_token);
        getUserByToken()
        .then(({data})=>{
          if(data && data.school_list.length === 0 && data.school_owned_amount === 0 && data.teacher_to_be_confirmed.length === 0){
            this.setState({pageState: 'startTrial'})
          } else if (data && (data.school_list.length>0 || data.teacher_to_be_confirmed.length> 0) && data.school_owned_amount === 0){
            window.location.href = '/';
          }else {
            this.setState({
              errorMessage: '',
              signingIn: false,
              signedIn: true,
            });
    
            window.location.href = '/';
          }
        })
        // getSubscriptionCtrl()
        //   .then((res)=>{
        //     if(res.data.maximum_amount.maximum_school === 0){
        //       this.setState({pageState: 'startTrial'})
        //     }else {
        //       this.setState({
        //         errorMessage: '',
        //         signingIn: false,
        //         signedIn: true,
        //       });
      
        //       window.location.href = '/';
        //     }
        //   })
      }

    }).catch((error)=>{
      console.error(error);
    });;
  }

  registerUser() {
    const { newPassword, verificationCode, username, agentId, email} = this.state;
    let phone = username.country_code + username.national_number;

    registerUser({phone, pin: verificationCode, new_password: newPassword, agent_id: agentId, email})
    .then((res) => {
      if(res.result == 'success'){
        loginAsUser({ username: phone, password: newPassword })
          .then((res)=>{
            const {
              result,
              user_token,
            } = res.data;

            if (result === 'success') {
              localStorage.setItem('token', user_token);
              getUserByToken()
                .then(({data})=>{
                  if(data && data.school_list.length === 0 && data.school_owned_amount === 0 && data.teacher_to_be_confirmed.length === 0){
                    this.setState({pageState: 'startTrial'})
                  } else if (data && (data.school_list.length>0 || data.teacher_to_be_confirmed.length> 0) && data.school_owned_amount === 0){
                    window.location.href = '/';
                  }else {
                    this.setState({
                      errorMessage: '',
                      signingIn: false,
                      signedIn: true,
                    });
            
                    window.location.href = '/';
                  }
                })
            }
          }).catch((error)=>{
            console.error(error);
          });
      } else if(res.result == 'failure'){
        this.setState({errorMessage: res.reason})
      }
    })
  }

  sum(x, y){
    return x + y
  }
  setVerificationCounter() {
    this.setState({ resendCode: true })
    this.timmer = setInterval(() => {
      if (this.state.counterTime > 0) {
        this.setState({ counterTime: (this.state.counterTime - 1) });
      } else {
        this.setState({ resendCode: false, counterTime: COUNT_DOWN_SECONDS });
        this.clearCounter();
      }
    }, 1000);
  }

  clearCounter() {
    clearInterval(this.timmer);
  }
  sendVerificationCode(){
    const {username} = this.state;
    let phone = username.country_code + username.national_number;

    sendPhoneVerification({phone, check_phone: 'sendIfUserNotExist'})
    .then((res) => {
      if(res.result == 'success'){
        this.setVerificationCounter();
      } else{
        this.setState({errorMessage: res.result})
      } 
    })
    .catch((err) => {
      this.setState({showVerificationFailure: true})
    })
  }
  matchErrorMessages(){
    const { errorMessage } = this.state;
    switch(errorMessage){
      case 'The Phone No./Password combination is not valid':
      case 'username does not exist':
      case 'wrong password':
        return __('The Phone No./Password combination is not valid', locale);
      case 'new password is less than 6 characters':
        return __('Password has to be at least 6 characters long', locale);
      case 'User already exists': 
      case 'user with this phone has registered':
        return __('User already exists', locale);
      case 'pin is wrong': 
      case 'please request the verification code first':
        return __('Invalid verification code', locale);
      case 'The verification code has expired': 
        return __('Verification code is expired', locale);
      default: 
        return __('Unexpected errors', locale) 
    }
  }
  startTrial(){
    beginTrial()
      .then((res)=>{
        if(res.result === 'success'){
          window.location.href = '/';
        }else {
          alert.warning(__('You have used the free trial', locale))
        }
      })

  }
  renderLoginForm(){
    const {
      username,
      password,
      errorMessage,
      signingIn
    } = this.state;

    let newUserName = username.country_code + username.national_number

    const ready = (newUserName.length > 6 && password.length > 3) || signingIn == true;

    return (
      <div className='LoginColumn'>
        <h2>{__('Log In to ClassTopBase', locale)}</h2>
        {
          errorMessage.length>0 &&
          <div className='errorMessage'>{this.matchErrorMessages()}</div>
        }
        <section className='login'>
          <div className='form-group'>
            <PhoneNumber defaultCountry={'ca'} value={username} onChange={(username)=>{
              this.setState({username});
            }} />
          </div>
          <div className='form-group password'>
            <span className='password-icon'><i className="icon-lock"></i></span>
            <input type='password' className='form-control' onChange={(e)=>{
                this.setState({
                  password: e.target.value,
                });
              }}
              onKeyPress={(e)=>{
                if (e.charCode === 13) {
                  this.login();
                }
              }}
            />
          </div>
        </section>
        <section className='control'>
          <a className='btn btn-primary' disabled={!ready} onClick={this.login}>{__('Sign In', locale)}</a>
          <a className='btn-link' onClick={this.forgotPassword}>{__('Forgot Your Password?', locale)}</a>

          <div className='line'>
            <hr />
            <div className='or'>or</div>
          </div>

          <a className='btn' onClick={()=>this.setState({pageState: 'signup', errorMessage: ''})}>{__('Register New Account', locale)}</a>
        </section>
      </div>
    );
  }
  renderSignupForm(){
    const {
      username,
      password,
      newPassword,
      errorMessage,
      showPassword,
      resendCode,
      counterTime,
      verificationCode,
      email
    } = this.state;

    let newPhone = username.country_code + username.national_number

    const validPhone = newPhone.length > 6;
    const validEmail = validator.isEmail(email.trim());
    
    return (
      <div className='LoginColumn'>
        <h2>{__('Sign up to ClassTopBase', locale)}</h2>
        {
          errorMessage.length>0 &&
          <div className='errorMessage'>{this.matchErrorMessages()}</div>
        }
        <section className='login'>
          <div className='field-label'>{__('Phone Number', locale)}</div>
          <div className='form-group'>
            <PhoneNumber defaultCountry={'ca'} value={username} onChange={(username)=>{
              this.setState({username});
            }} />
          </div>
          <div className='field-label'>{__('Verification Code', locale)}</div>
          <div className='form-group verification-wrapper'>
            <input type='number' placeholder={__('4 digits', locale)} value={verificationCode} className='form-control' onChange={(e)=>this.setState({verificationCode: e.target.value})}/>
            <button className='btn btn-primary' onClick={this.sendVerificationCode} disabled={!validPhone || resendCode}>
              {resendCode? __('Resend in {counterTime}s', locale, {counterTime}): __('Send Code', locale)}
            </button>
          </div>
          <div className='field-label'>{__('Password', locale)}</div>
          <div className='form-group password'>
            <span className='password-icon'><i className="icon-lock"></i></span>
            <input type={showPassword? 'text': 'password'}  placeholder={__('At least 6 characters', locale)} className='form-control' onChange={(e)=>{
                this.setState({
                  newPassword: e.target.value,
                });
              }}
            />
            <span className='toggle-text' onClick={()=>this.setState({showPassword: !showPassword})}>{showPassword? __('hide', locale): __('show', locale)}</span>
          </div>
          <div className='field-label'>{__('Email', locale)}</div>
          <div className='form-group email'>
            <input type='email' className='form-control' placeholder="eg. name@mail.com" onChange={(e)=>this.setState({email: e.target.value})} />
          </div>
          <div className='agreement-text'>{__('By clicking Register, you agree to our ', 'appwrapper')}
            <a target="_blank" href={__('https://base.classtop.com/terms-of-service-en.html', 'appwrapper')}>{__('Terms of Service', 'appwrapper')}</a>
          </div>
        </section>
        <section className='control'>
          <a className='btn btn-primary' disabled={!validPhone || newPassword.length<6 || verificationCode.length<4 || !validEmail} onClick={this.registerUser}>{__('Register', locale)}</a>
          <div className='line'>
            <hr />
            <div className='or'>{__('Or', locale)}</div>
          </div>
          <a className='btn' onClick={()=>this.setState({pageState: 'login', errorMessage: ''})}>{__('Sign In', locale)}</a>
        </section>
      </div>
    );
  }

  renderTrailSection(){
    return (
      <div className='trail-section'> 
        <h1 className='section-title'>{__('Start your 14 days free trail now!', 'planDetails')}</h1>
        <div className='section-description'>
          <div className='included-features'>
            <div className='feature-title'>{__('Features that are included in free trial', 'planDetails')}:</div>
            <ul>
              <li><i className='fa icon-ok check-icon'></i>{__('All basic plan features', 'planDetails')}</li>
              <li><i className='fa icon-ok check-icon'></i>{__('{amount} Registered Students', 'planDetails', {amount: 80})}</li>
              <li><i className='fa icon-ok check-icon'></i>{__('{amount} Registered Teachers', 'planDetails', {amount: 40})}</li>
              <li><i className='fa icon-ok check-icon'></i>{__('{amount} Campus', 'planDetails', {amount: 1})}</li>
            </ul>
          </div>
          <div className='excluded-features'>
            <div className='feature-title'>{__('Features that are NOT included', 'planDetails')}:</div>
            <ul>
              <li><i className='fa icon-cancel close-icon'></i>{__('No Posters', 'planDetails')}</li>
              <li><i className='fa icon-cancel close-icon'></i>{__('No Contacts', 'planDetails')}</li>
              <li><i className='fa icon-cancel close-icon'></i>{__('No Smart Check-in', 'planDetails')}</li>
              <li><i className='fa icon-cancel close-icon'></i>{__('No Recent Activity Logs', 'planDetails')}</li>
            </ul>
          </div>
        </div>
        <button className="btn btn-primary btn-start-trial" onClick={this.startTrial}>{__('Start My Trial', 'planDetails')}</button>
      </div>
    )
  }

  render() {
    const {
      signedIn,
      pageState
    } = this.state;

    return (
      <div className={classnames('Login', { signedIn })}>
        <div className='Loading'>
          <Loading type='logo' />
        </div>
        <div className='Content'>
          {
            pageState === 'login' && this.renderLoginForm()
          }
          {
            pageState === 'signup' && this.renderSignupForm()
          }
          {
            pageState === 'startTrial' && this.renderTrailSection()
          }
          <div className='bg-1 overlay' style={{ backgroundImage: `url(${bg})`, }}>
              <img src={logo} width={182} className='logo' />
            <div className='title'>
              <h1>{__('EASY SOLUTION', locale)}</h1>
              <h4>{__('FOR YOUR SCHOOL MANAGEMENT', locale)}</h4>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(Login);


// WEBPACK FOOTER //
// ./src/containers/pages/Login/index.js